import { Injectable, NgModule } from "@angular/core";
import { HotToastModule, HotToastService, ToastPosition } from "@ngneat/hot-toast";

@Injectable()
export class ToastService {
  constructor(private toast: HotToastService) {}
  show(message: string, duration: number = 3000, dismissible = true): void {
    this.toast.warning(message, {
      duration,
      id: "pause",
      position: "bottom-center",
      className: "ui-toast",
      dismissible,
    });
  }
  showInfo(message: string, duration: number = 3000, dismissible = true): void {
    this.toast.info(message, {
      duration,
      id: "pause",
      position: "bottom-center",
      dismissible,
      className: "ui-toast",
    });
  }
  showDismissible(message: string): void {
    this.toast.show(message, {
      autoClose: false,
      dismissible: true,
      position: "bottom-center",
      className: "ui-toast",
    });
  }

  showCustomToast(
    message: string,
    type: "warning" | "info" | "error" | "success",
    dismissible = true,
    autoClose = true,
    duration = 3000,
  ): void {
    
    const toast_settings = {
      autoClose,
      dismissible,
      duration: dismissible ? duration : undefined,
      position: "bottom-right" as ToastPosition,
    }

    switch (type) {
      case "warning":
        this.toast.warning(message, {
          ...toast_settings,
          className: "ui-toast ui-toast-warning"
        });
        break;
      case "info":
        this.toast.info(message, {
          ...toast_settings,
          className: "ui-toast ui-toast-info"
        });
        break;
      case "error":
        this.toast.error(message, {
          ...toast_settings,
          className: "ui-toast ui-toast-error"
        });
        break;
      case "success":
        this.toast.success(message, {
          ...toast_settings,
          className: "ui-toast ui-toast-success",
        });
        break;
    }
    
  }
}

@NgModule({
  imports: [HotToastModule.forRoot()],
  providers: [ToastService],
})
export class ToastServiceModule {}
